export const SearchService = {
    getResults: async (query) => {
        return axios.get(
            // `${window.location.origin}/api/v1/search?query=*${query}*`
            window.searchApi, { params: { query: `*${query}*` } }
        );
    },
};
